// All 106 French departments (métropole + Corse + DOM-COM)
// Source: https://annuaire-entreprises.data.gouv.fr/departements/index.html
export const FRENCH_DEPARTMENTS = [
    ["", "All departments"],
    ["01", "01 · Ain"], ["02", "02 · Aisne"], ["03", "03 · Allier"],
    ["04", "04 · Alpes-de-Haute-Provence"], ["05", "05 · Hautes-Alpes"],
    ["06", "06 · Alpes-Maritimes"], ["07", "07 · Ardèche"], ["08", "08 · Ardennes"],
    ["09", "09 · Ariège"], ["10", "10 · Aube"], ["11", "11 · Aude"], ["12", "12 · Aveyron"],
    ["13", "13 · Bouches-du-Rhône"], ["14", "14 · Calvados"], ["15", "15 · Cantal"],
    ["16", "16 · Charente"], ["17", "17 · Charente-Maritime"], ["18", "18 · Cher"],
    ["19", "19 · Corrèze"], ["21", "21 · Côte-d'Or"], ["22", "22 · Côtes-d'Armor"],
    ["23", "23 · Creuse"], ["24", "24 · Dordogne"], ["25", "25 · Doubs"],
    ["26", "26 · Drôme"], ["27", "27 · Eure"], ["28", "28 · Eure-et-Loir"],
    ["29", "29 · Finistère"], ["2A", "2A · Corse-du-Sud"], ["2B", "2B · Haute-Corse"],
    ["30", "30 · Gard"], ["31", "31 · Haute-Garonne"], ["32", "32 · Gers"],
    ["33", "33 · Gironde"], ["34", "34 · Hérault"], ["35", "35 · Ille-et-Vilaine"],
    ["36", "36 · Indre"], ["37", "37 · Indre-et-Loire"], ["38", "38 · Isère"],
    ["39", "39 · Jura"], ["40", "40 · Landes"], ["41", "41 · Loir-et-Cher"],
    ["42", "42 · Loire"], ["43", "43 · Haute-Loire"], ["44", "44 · Loire-Atlantique"],
    ["45", "45 · Loiret"], ["46", "46 · Lot"], ["47", "47 · Lot-et-Garonne"],
    ["48", "48 · Lozère"], ["49", "49 · Maine-et-Loire"], ["50", "50 · Manche"],
    ["51", "51 · Marne"], ["52", "52 · Haute-Marne"], ["53", "53 · Mayenne"],
    ["54", "54 · Meurthe-et-Moselle"], ["55", "55 · Meuse"], ["56", "56 · Morbihan"],
    ["57", "57 · Moselle"], ["58", "58 · Nièvre"], ["59", "59 · Nord"], ["60", "60 · Oise"],
    ["61", "61 · Orne"], ["62", "62 · Pas-de-Calais"], ["63", "63 · Puy-de-Dôme"],
    ["64", "64 · Pyrénées-Atlantiques"], ["65", "65 · Hautes-Pyrénées"],
    ["66", "66 · Pyrénées-Orientales"], ["67", "67 · Bas-Rhin"], ["68", "68 · Haut-Rhin"],
    ["69", "69 · Rhône"], ["70", "70 · Haute-Saône"], ["71", "71 · Saône-et-Loire"],
    ["72", "72 · Sarthe"], ["73", "73 · Savoie"], ["74", "74 · Haute-Savoie"],
    ["75", "75 · Paris"], ["76", "76 · Seine-Maritime"], ["77", "77 · Seine-et-Marne"],
    ["78", "78 · Yvelines"], ["79", "79 · Deux-Sèvres"], ["80", "80 · Somme"],
    ["81", "81 · Tarn"], ["82", "82 · Tarn-et-Garonne"], ["83", "83 · Var"],
    ["84", "84 · Vaucluse"], ["85", "85 · Vendée"], ["86", "86 · Vienne"],
    ["87", "87 · Haute-Vienne"], ["88", "88 · Vosges"], ["89", "89 · Yonne"],
    ["90", "90 · Territoire de Belfort"], ["91", "91 · Essonne"],
    ["92", "92 · Hauts-de-Seine"], ["93", "93 · Seine-Saint-Denis"],
    ["94", "94 · Val-de-Marne"], ["95", "95 · Val-d'Oise"],
    // DOM-COM
    ["971", "971 · Guadeloupe"], ["972", "972 · Martinique"], ["973", "973 · Guyane"],
    ["974", "974 · La Réunion"], ["975", "975 · Saint-Pierre-et-Miquelon"],
    ["976", "976 · Mayotte"], ["977", "977 · Saint-Barthélemy"],
    ["978", "978 · Saint-Martin"], ["986", "986 · Wallis-et-Futuna"],
    ["987", "987 · Polynésie française"], ["988", "988 · Nouvelle-Calédonie"],
];

// Common NAF activity codes with human labels
export const NAF_SHORTCUTS = [
    { code: "88.91A", label: "Childcare / Crèches (88.91A)" },
    { code: "88.91B", label: "Childcare / Halte-garderies (88.91B)" },
    { code: "62.01Z", label: "SaaS · Software programming (62.01Z)" },
    { code: "62.02A", label: "IT consulting (62.02A)" },
    { code: "70.22Z", label: "Business consulting (70.22Z)" },
    { code: "73.11Z", label: "Marketing / advertising agencies (73.11Z)" },
    { code: "64.19Z", label: "Banking (64.19Z)" },
    { code: "64.99Z", label: "Fintech / financial services (64.99Z)" },
    { code: "66.19B", label: "Financial intermediaries (66.19B)" },
    { code: "86.10Z", label: "Hospitals (86.10Z)" },
    { code: "86.90F", label: "Alternative medicine (86.90F)" },
    { code: "56.10A", label: "Restaurants (56.10A)" },
    { code: "56.10C", label: "Fast-food (56.10C)" },
    { code: "47.11B", label: "Small grocery stores (47.11B)" },
    { code: "47.91B", label: "E-commerce (47.91B)" },
    { code: "85.32Z", label: "Vocational training (85.32Z)" },
    { code: "85.59A", label: "Adult training (85.59A)" },
    { code: "43.21A", label: "Electrical installation (43.21A)" },
    { code: "41.20A", label: "Residential construction (41.20A)" },
    { code: "68.20B", label: "Real estate agencies (68.20B)" },
    { code: "78.10Z", label: "Recruiting agencies (78.10Z)" },
    { code: "78.20Z", label: "Temp work (78.20Z)" },
    { code: "49.41A", label: "Freight transport (49.41A)" },
    { code: "52.29A", label: "Freight forwarding (52.29A)" },
    { code: "26.20Z", label: "Computer manufacturing (26.20Z)" },
    { code: "72.19Z", label: "AI / ML research (72.19Z)" },
    { code: "69.10Z", label: "Legal services (69.10Z)" },
    { code: "69.20Z", label: "Accounting (69.20Z)" },
    { code: "65.11Z", label: "Life insurance (65.11Z)" },
    { code: "35.11Z", label: "Electricity production (35.11Z)" },
    { code: "10.71A", label: "Bakeries (10.71A)" },
    { code: "10.71B", label: "Pastry shops (10.71B)" },
    { code: "96.02A", label: "Hairdressers (96.02A)" },
    { code: "96.02B", label: "Beauty salons (96.02B)" },
];
